<template>
    <!-- 遮罩层 -->
    <div class="exam_seat_page exam_seat_page_small" @click.self="handleCancel">
        <div class="exac_title" v-if="orderData">
            {{
                currentLocale === "zh-CN"
                    ? orderData.examTitle
                    : orderData.examTitleEn
            }}
        </div>
        <div class="exam_seat_content">
            <!-- 考期规则 -->
            <div class="exam_rules">
                <div class="rules_title">{{ $t("examDetail.rulesTitle") }}</div>
                <ul class="rules_list">
                    <li v-html="rules"></li>
                </ul>
            </div>

            <!-- 选择考位 -->
            <div class="exam_selection">
                <div class="rules_title">{{ seatTitle }}</div>
                <div class="selection_select">
                    <div class="selection_title">
                        <!-- popper-class="custom-select-dropdown" -->
                        <el-select
                            v-model="selectedPosition"
                            :placeholder="$t('examDetail.placeHolderOne')"
                            @change="onPositionChange"
                            popper-class="custom-select-dropdown"
                        >
                            <el-option
                                v-for="item in positionList"
                                :key="item.id"
                                :label="
                                    currentLocale === 'zh-CN'
                                        ? item.name
                                        : item.nameEn
                                "
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div class="selection_title">
                        <el-select
                            v-model="selectedYear"
                            :placeholder="$t('examDetail.placeHolderTwo')"
                            @change="onYearChange"
                            popper-class="custom-select-dropdown"
                        >
                            <el-option
                                v-for="item in yearList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <!-- 考位选项 -->
                <div class="slot_options">
                    <el-radio-group v-model="selecExamTime" size="big">
                        <el-radio
                            v-for="(item, index) in filteredTimeList"
                            :key="index"
                            :label="item.id"
                            size="medium"
                        >
                            <template #default>
                                <div class="slot_item">
                                    <div class="slot_time">
                                        <span class="label">
                                            {{
                                                currentLocale === "zh-CN"
                                                    ? "开考时间"
                                                    : "Exam opening time"
                                            }}
                                        </span>
                                        <span class="value"
                                            >{{
                                                currentLocale === "zh-CN"
                                                    ? formatChineseNoYear(item.examTime)
                                                    : formatEnglish(item.examTime)
                                            }}
                                            {{
                                                currentLocale === "zh-CN"
                                                    ? item.sessions
                                                    : item.sessionsEn
                                            }}</span
                                        >
                                    </div>
                                    <div class="slot_seats">
                                        <img
                                            src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/个人中心.png"
                                            alt=""
                                        />
                                        <span class="label">{{
                                            currentLocale === "zh-CN"
                                                ? "剩余考位："
                                                : "Remaining exam seats: "
                                        }}</span>
                                        <span class="value">{{
                                            item.minSeats
                                        }}</span>
                                    </div>
                                    <div class="slot_duration">
                                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/时长.png" alt="" />
                                        <!-- <span class="label">考试时长：</span> -->
                                        <span class="value">
                                            <span class="label"
                                                >{{
                                                    $t("examDetail.duration")
                                                }}：</span
                                            >
                                            <span class="value">
                                                {{ item.duration
                                                }}{{
                                                    currentLocale === "zh-CN"
                                                        ? "分钟"
                                                        : "minute"
                                                }}
                                            </span></span
                                        >
                                    </div>
                                    <div class="slot_deadline">
                                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/时间.png" alt="" />
                                        <span class="label">
                                            {{
                                                currentLocale === "zh-CN"
                                                    ? "报名截止时间："
                                                    : "Regular registration deadline："
                                            }}
                                        </span>
                                        <span class="value">{{
                                            currentLocale === "zh-CN"
                                                ? formatChineseNoYear(item.deadlineTime)
                                                : formatEnglish(item.deadlineTime)
                                        }}</span>
                                    </div>
                                    <!-- <i class="el-icon-success"></i> -->
                                    <i
                                        class="el-icon-success"
                                        v-if="selecExamTime == item.id"
                                    ></i>
                                    <i class="nocheck-radio" v-else></i>
                                    <!-- <p>{{ selecExamTime }}</p> -->
                                    <p
                                        class="bottomdes"
                                        v-if="item.isOverdue"
                                        style="color: red"
                                    >
                                        {{
                                            currentLocale === "zh-CN"
                                                ? `报名已结束，逾期报名将收取常规考试费用的20%作为逾期报名费`
                                                : "registration is closed. A 20% late fee applies"
                                        }}
                                    </p>
                                </div>
                            </template>
                        </el-radio>
                    </el-radio-group>
                </div>
                <!-- 确认按钮 -->
                
                <div class="re_confirm_btn">
                    <div style="padding-left: 16px">
                        <span v-if="gettransferFee()" style="color: red; font-weight: bold;">
                            {{currentLocale === 'zh-CN' ? ' 手续费：': 'Transaction Fee ：'		}}
                            {{gettransferFee()}} {{ currentLocale === 'zh-CN' ? '元' : 'USD'  }}
                        </span>
                    </div>
                    <div class="p1">
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/向下更多.png" alt="" />
                        向下滑动查看更多考位
                    </div>
                    <div class="p2" @click="handleConfirm1">
                        
                        <p>{{confirmBtnText}}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 修改考位成功 -->
        <Modal
            :showModal="showModal"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            show-size="small"
            @confirm="handleConfirm"
            @cancel="handleConfirm"
        >
            <!-- 自定义内容插槽 -->
            <template #content>
                <div class="sure_checkout_content">
                    <el-result icon="success" size="large" class="result-image">
                        <template slot="extra">
                            <p class="p_text">
                                {{ $t("examDetail.successTitle") }}
                            </p>
                            <p class="p_text">
                                {{ $t("examDetail.successDate") }}
                                {{ successDate }}
                            </p>
                            <p class="p_text">
                                {{ $t("examDetail.successPosition") }}
                                {{ successPosition }}
                            </p>
                        </template>
                    </el-result>
                </div>
            </template>
            <!-- 自定义按钮插槽 -->
            <template #footer>
                <!-- <button class="btn-submit" @click="submitCustom">提交申请</button> -->
            </template>
        </Modal>
        <!-- 支付model -->
         <Modal
            :showModal="showModal1"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-submit="false"
            :show-delete-icon="true"
            show-size="small"
            @confirm="sureConfirm1"
            @cancel="handleCancel1"
        >
            <template #content>
                <div class="sure_pay_content">
                    <p class="p_img">
                        <el-image  v-if="payImg"
                            :src="payImg"
                            :preview-src-list="[
                                payImg
                            ]">
                        </el-image>
                    </p>
                    <p class="p_text1">
                        {{ currentLocale === "zh-CN" ? "请使用支付宝或微信扫码完成支付" : "Please scan the QR code with Alipay or WeChat to complete your payment." }}
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/微信.png" alt="" />
                        <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/支付宝.png" alt="" />
                    </p>
                </div>
            </template>
            <template #footer> </template>
        </Modal>
        <!-- 支付成功 -->
         <Modal
            :showModal="showModal2"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-delete-icon="false"
            show-size="small"
            @confirm="handleConfirm2"
            @cancel="handleCancel2"
        >
            <template #content>
                <div class="cancel_pay_content">
                    <el-result icon="success" class="result-image">
                        <template slot="extra">
                            <p class="cancel_text"> {{ $t('payment.descOne') }}</p>
                            <p class="cancel_text1"> {{ $t('payment.descTwo') }}</p>
                        </template>
                    </el-result>
                </div>
            </template>
            <template #footer> </template>
        </Modal>
    </div>
</template>

<script>
import {
    getOrderDetailRescource,
    getreSourcePoint,
    getPositionRescource,
    updateOrderPosition,
    getTransferOrderId,
    queryOrderPayDetail
} from "@/plugins/api";
import { toCST, formatChinese, formatChineseNoYear, formatEnglish, getYear, getMonth, getDay, formatEnglishFull } from "@/utils/date";

export default {
    name: "examSeatModal",
    props: {
        orderData: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            selected: "",
            deraction: "bottom",
            examId: "",
            examData: {},
            positionList: [],
            positionTimeList: [],
            selectedPosition: "", // 当前选中的考点
            yearList: [],
            selectedYear: "", // 当前选中的年份
            filteredTimeList: [], // 当前展示的考位时间
            currentLocale: "zh-CN",
            selectedTimeItem: null,
            orderObj: null, // 新增
            isEditOrder: true, // 是否为修改订单
            showSuccessPopup: false, // 控制修改成功弹窗
            successDate: "",
            successPosition: "",
            examIdList: [],
            checkList: [],
            selectedExams: [],
            selecExamTime: null,
            showModal: false,
            showModal1: false,
            showModal2: false,
            intervalId: null
        };
    },
    watch: {
        initialCaseDetails(newVal) {
            this.caseDetails = newVal;
        },
        orderData() {
            this.getPositionList();
        },
        "$i18n.locale": {
            handler(newVal) {
                this.currentLocale = newVal || "zh-CN";
                if (newVal === "zh-CN") {
                    this.rules = `1. 考生在8周内最多可以参加两次考试，这两次考试可以以任何组合形式参加单个或多个模块的考试（口语、听力、阅读和写作） <br> 2. 考生在12个月内最多可以参加四次考试， 这四次考试可以以任何组合形式参加单个或多个模块的考试(口语、 听力、 阅读和写作)`;
                } else {
                    this.rules =
                        "Test takers may retake individual modules or a complete test. Test takers can take tests or modules on a maximum of two occasions (test sessions) in any 8-week period, and a maximum of four occasions (test sessions) in any 12-month period.\nThe 8-week rule. The maximum number of occasions (test sessions) that a test taker can take any test ormodule in the Oxford Test of English suite in an eight-week period is two.\nThe 12-month rule: The maximum number of occasions (test sessions) that a test taker can take any test or module in the Oxford Test of English suite in a 12-month period is four. ";
                }
            },
            immediate: true,
        },
    },
    created() {
        // console.log(this.orderData, "this.orderData");
        this.selectedExams = this.orderData.examList;
        this.getPositionList();
        // this.currentLocale = this.$i18n.locale || "zh-CN";
    },
    computed: {
        seatTitle() {
            return this.isEditOrder
                ? this.$t("examDetail.reselectSeat")
                : this.$t("examDetail.chooseSeat");
        },
        confirmBtnText() {
            const obj = this.filteredTimeList.find(
                (item) => item.id === this.selecExamTime
            );
            return this.isEditOrder ?
				obj && obj.transferFee ? this.$t('examDetail.reselectBtn1'):  this.$t('examDetail.reselectBtn') :
				this.$t('examDetail.confirm');
        },
        bottomDate() {
            if (!this.selectedTimeItem) return "";
            if (this.currentLocale === "zh-CN") {
                return `${formatChinese(this.selectedTimeItem.examTime)} ${this.selectedTimeItem.sessions}`;
            } else {
                return `${formatEnglishFull(this.selectedTimeItem.examTime)} ${this.selectedTimeItem.sessionsEn}`;
            }
        },
        selectedPositionText() {
            if (
                !this.orderData ||
                !this.orderData.positionInfo ||
                !this.orderData.positionInfo.exam_point
            )
                return "";
            return this.currentLocale === "zh-CN"
                ? this.orderData.positionInfo.exam_point.name
                : this.orderData.positionInfo.exam_point.nameEn;
        },
        selectedYearText() {
            if (!this.orderData || !this.orderData.positionInfo) return "";
            const year = getYear(this.orderData.positionInfo.examTime);
            return this.currentLocale === "zh-CN" ? `${year}年` : `${year}`;
        },
        // 动态考点下拉数据
        selectedRange() {
            if (!this.orderData || !this.orderData.positionInfo) return [];
            return [
                {
                    value: 0,
                    text:
                        this.currentLocale === "zh-CN"
                            ? this.orderData.positionInfo.position
                            : this.orderData.positionInfo.positionEn,
                },
            ];
        },
        // 动态年份下拉数据
        selectedYearList() {
            if (!this.orderData || !this.orderData.positionInfo) return [];
            const year = getYear(this.orderData.positionInfo.examTime);
            return [
                {
                    value: year,
                    text:
                        this.currentLocale === "zh-CN"
                            ? `${year}年`
                            : `${year}`,
                },
            ];
        },
        // 动态考试日期
        selectedExamDateText() {
            if (!this.orderData || !this.orderData.positionInfo) return "";
            const examTime = this.orderData.positionInfo.examTime;
            return this.currentLocale === "zh-CN"
                ? `${formatChinese(examTime)} ${this.orderData.positionInfo.sessions}`
                : `${formatEnglish(examTime)} ${this.orderData.positionInfo.sessions}`;
        },
        selectedExamDateText1() {
            if (!this.orderData || !this.orderData.positionInfo) return "";
            const exam_point = this.orderData.positionInfo.exam_point
                ? this.orderData.positionInfo.exam_point
                : "";
            return this.currentLocale === "zh-CN"
                ? exam_point.name
                : exam_point.nameEn;
            // return this.currentLocale === "zh-CN"
            //     ? this.orderData.positionInfo.sessions
            //     : this.orderData.positionInfo.sessionsEn;
        },
        // 动态截止日期
        selectedDeadlineText() {
            if (!this.orderData || !this.orderData.positionInfo) return "";
            const deadlineTime = this.orderData.positionInfo.deadlineTime;
            return this.currentLocale === "zh-CN"
                ? `报名截止时间：${formatChineseNoYear(deadlineTime)}`
                : `registration deadline: ${formatEnglish(deadlineTime)}`;
        },
    },
    methods: {
        // 订单页面跳转来修改考位的话获取订单的详情
        // async getOrderDetailAndInit() {
        //     uni.showLoading({
        //         title:
        //             this.currentLocale === "zh-CN" ? "加载中..." : "Loading...",
        //     });
        //     try {
        //         // 获取订单详情
        //         const res = await RequestApi.getOrderDetailRescource(
        //             this.orderId
        //         );
        //         if (res) {
        //             this.orderObj = res;
        //             this.examData = res.examInfo;
        //             this.examIdList = res.examIds;
        //             this.checkList = encodeURIComponent(
        //                 JSON.stringify(res.examList)
        //             );
        //         }
        //     } catch {
        //         // uni.hideLoading();
        //     } finally {
        //         uni.hideLoading();
        //     }
        // },
        // 获取考位信息
        async getPositionList() {
            const res = await getreSourcePoint({channelCode: this.orderData.channelCode, orderId: this.orderData.id});
            this.positionList = res;
        },
        async onPositionChange(val) {
            this.selectedPosition = val;
            if (!val) {
                // 清空年份数据以及日期
                this.selectedYear = "";
                this.selected = "";
                this.yearList = [];
                this.filteredTimeList = [];
                this.selecExamTime = ''
            } else {
                await this.getPositionTimeList(val);
                this.generateYearList();
                this.selectedYear =
                    this.yearList.length > 0 ? this.yearList[0].id : "";
                this.filterTimeList();
            }
        },
        // 获取考位时间信息
        async getPositionTimeList(position) {
            let list = this.selectedExams.map((item) => item.id);
            let obj = {
                examPointId: position,
                examPositionId: this.orderData && this.orderData.examPositionId ? this.orderData.examPositionId : null,
                examIds: list,
                orderId: this.orderData.id,
                channelCode: this.orderData.channelCode
            };
            const res = await getPositionRescource(obj);
            this.positionTimeList = res;
        },
        generateYearList() {
            const years = Array.from(
                new Set(
                    this.positionTimeList.map((item) => {
                        return getYear(item.examTime);
                    })
                )
            );
            // 对年份进行正序排序（从小到大）
            years.sort((a, b) => a - b);
            this.yearList = years.map((y) => ({
                id: y,
                name: this.currentLocale === "zh-CN" ? `${y}年` : `${y}`,
            }));
        },
        onYearChange(val) {
            this.selectedYear = val;
            if (!val) {
                this.filteredTimeList = [];
                this.selected = "";
                this.selecExamTime = ''
            } else {
                this.filterTimeList();
            }
        },

        filterTimeList() {
            this.filteredTimeList = this.positionTimeList.filter((item) => {
                return getYear(item.examTime) == this.selectedYear;
            });
            this.filteredTimeList.sort((a, b) => {
                return getMonth(a.examTime) - getMonth(b.examTime);
            });
        },
        updateSuccessInfo() {
            if (this.currentLocale === "zh-CN") {
                this.successDate = formatChinese(this.selectedTimeItem.examTime);
            } else {
                this.successDate = formatEnglishFull(this.selectedTimeItem.examTime);
            }
            const obj = this.positionList.find(
                (item) => item.id === this.selectedPosition
            );
            this.successPosition = obj.name;
        },
        handleConfirm2() {
            this.showModal2 = false;
            this.showModal1 = false
            clearInterval(this.intervalId);
            this.$emit("sureReat", false);
            this.showModal = false;
        },
        handleCancel2() {
            this.showModal2 = false;
            this.showModal1 = false
            clearInterval(this.intervalId);
            this.$emit("sureReat", false);
            this.showModal = false;
        },

        sureConfirm1() {
            this.showModal1 = false;
            clearInterval(this.intervalId);
        },
        handleCancel1() {
            this.showModal1 = false;
            clearInterval(this.intervalId);
        },
        async handleConfirm1() {
            if (!this.selecExamTime) {
                this.$message.error(
                    this.currentLocale === "zh-CN"
                        ? "请选择考位时间"
                        : "Please select exam time"
                );
                return;
            }
            const obj = this.filteredTimeList.find(
                (item) => item.id === this.selecExamTime
            );
            this.selectedTimeItem = obj;
            if (Number(obj.transferFee) > 0) {
				    this.handlePayment()
				} 
            else {  
                await updateOrderPosition(this.orderData.id, {
                    examPositionId: this.selectedPosition,
                    positionObj: obj,
                });
                this.updateSuccessInfo();
                this.showModal = true;
            }
        },
        async handlePayment() {
            // 处理手续费支付逻辑
            try {
                let payParams = null;
                const params = {
                    orderId: this.orderData.id,
                    language: this.currentLocale === "zh-CN"?"zh" : "en",
                    isWeb: true,
                    targetPositionId: this.selectedTimeItem.id
                };
                payParams = await getTransferOrderId(params);
                this.payImg = payParams.qrCodeStr ? payParams.qrCodeStr : "";
                const that = this
                this.orderId = payParams.orderId
                this.showModal1 = true;
                 if (this.intervalId) {
                    clearInterval(this.intervalId);
                }
                this.intervalId = setInterval(function () {
                    that.getPayDetail(payParams.reqsn);
                }, 2000);
            } catch (err) {
                let msg =
                    this.currentLocale === "zh-CN"
                        ? "支付失败"
                        : "Update Failed";
                if (err && err.data && err.data.error) {
                    msg =
                        this.currentLocale === "zh-CN"
                            ? err.data.error.returnUserMessage ||
                              err.data.error.returnMessage
                            : err.data.error.returnUserMessageEn ||
                              err.data.error.returnMessageEn ||
                              err.data.error.returnMessage;
                }
                this.$message({
                    message: msg,
                    type: "error",
                });
            } finally {
            }
        },
          async getPayDetail(reqsn) {
            await queryOrderPayDetail({reqsn: reqsn})
                .then((res) => {
                    if (res.message === "交易成功" || res.message === "查询成功" ||  res.message === "支付成功") {
                        this.showModal2 = true;
                        this.isPaying = false
                        clearInterval(this.intervalId);
                        this.showModal1 = false
                    }
                    if (res.message === "已取消") {
                        this.isPaying = false
                        clearInterval(this.intervalId);
                    }
                })
                .catch(() => {});
        },
        gettransferFee() {
            if (!this.selecExamTime) {
                return;
            }
            const obj = this.filteredTimeList.find(
                (item) => item.id === this.selecExamTime
            );
            return obj && obj.transferFee ? obj.transferFee : 0
        },
        handleConfirm() {
            this.$emit("sureReat", false);
            this.showModal = false;
        },
    },
};
</script>

<style lang="stylus" scoped>
.exam_seat_page {
    font-family: 'Microsoft YaHei', sans-serif;
    color: #333;
    max-width: 1200px;
    margin: 0 auto;
    // padding: 20px;
    // background: #fff;
    z-index: 1;

    .exac_title {
        font-weight: bold;
        font-size: 26px;
        color: #011E41;
        line-height: 33px;

        &:after {
            content: ' ';
            display: block;
            width: 100%;
            height: 4px;
            background: linear-gradient(90deg, #E2CB24 0%, #50B9AA 100%);
            margin: 12px 0;
        }
    }

    .exam_seat_content {
        overflow: scroll;
        height: calc(100vh - 420px);
    }

    // 考期规则
    .exam_rules {
        margin-bottom: 30px;

        .rules_list {
            list-style-type: none;
            padding-left: 0;

            li {
                font-size: 18px;
                position: relative;
                font-size: 18px;
                color: #011E41;
                line-height: 32px;
                // &::before {
                // content: '•';
                // position: absolute;
                // left: 0;
                // color: #000;
                // font-size: 24px;
                // }
            }

            li:last-child {
                padding-bottom: 20px;
                border-bottom: 1px solid #ddd;
            }
        }
    }

    .rules_title {
        font-weight: bold;
        margin-bottom: 8px;
        font-size: 22px;
        color: #011E41;
    }

    // 选择考位
    .exam_selection {
        .selection_select {
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: space-between;

            // gap: 20px;
            .selection_title {
                width: 49%;
                margin-bottom: 20px;

                .el-select {
                    width: 100%;
                }

                >>>.el-input__inner {
                    // height: 58px !important;
                    // line-height: 58px !important;
                    // background-color: #FAFCFF;
                    // border-radius: 10px;
                    // border: 1px solid #78A0D0;
                }
            }
        }

        .slot_options {
            // display: flex;
            // flex-direction: row;
            // flex-wrap: wrap;
            margin-bottom: 40px;
            max-height: 200px;
            overflow: scroll;

            ::v-deep .el-radio__inner {
                display: none;
            }

            .el-radio-group {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 1vw !important;
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(49%, 1fr));
                // margin-right: 0;
            }

            .el-radio {
                // width: 49%;
                // margin-right: 0;
                box-sizing: border-box;
                // display: grid;
                // grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
                margin-right: 0;
            }

            .slot_item {
                width: 100%;
                border: 1px solid #ddd;
                border-radius: 10px;
                padding: 20px;
                background: linear-gradient(0deg, #F0F7FF 0%, #FAFCFF 50%, #FAFCFF 100%);
                position: relative;

                // border: 1px solid #78A0D0;
                .slot_time {
                    display: flex;
                    align-items: center;
                    margin-bottom: 12px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .label, .value {
                        font-size: 22px;
                        color: #011E41;
                        font-weight: 600;
                    }
                }

                .slot_seats, .slot_duration, .slot_deadline {
                    display: flex;
                    align-items: center;

                    img {
                        width: 18px;
                        margin-right: 8px;
                    }

                    .label, .value {
                        font-size: 18px;
                        color: #011E41;
                        line-height: 33px;
                    }
                }

                > i {
                    position: absolute;
                    right: 20px;
                    top: 50%;
                    z-index: 1;
                    margin-top: -20px;
                }
            }
        }

        .confirm_btn {
            display: block;
            margin: 0 auto;
            color: #fff;
            font-size: 28px;
            font-weight: bold;
            border: none;
            cursor: pointer;
            text-align: center;
            width: 280px;
            height: 74px;
            background: #0043E0;
            border-radius: 37px;

            &:hover {
                background-color: #0043E8;
                color: #f5f5f5;
            }
        }

        .re_confirm_btn {
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: space-between;
            position: absolute;
            bottom: 10px;
            right: 10px;
            z-index: 2;
            width: 100%;
            background-color: #fff;

            > div {
                width: 33%;
            }

            .p1 {
                font-weight: 300;
                font-size: 18px;
                color: #0043E0;
                display: flex;
                flex-flow: row;
                align-items: center;
                justify-content: center;

                img {
                    width: 18px;
                }
            }

            .p2 {
                display: flex;
                flex-flow: row;
                align-items: center;
                justify-content: flex-end;

                p {
                    background: #0043E0;
                    border-radius: 22px;
                    font-weight: bold;
                    font-size: 18px;
                    padding: 10px 20px;
                    color: #FFFFFF;
                }
            }
        }
    }
    .sure_pay_content {
        padding: 10px;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;

        .p_text {
            font-size: 20px;
            color: #011E41;
            line-height: 33px;

            >span {
                font-size: 26px;
                color: #0043E0;
                line-height: 33px;
            }
        }

        .p_img {
            width: 266px;
            height: 266px;
            margin: 10px 0;

            .el-image {
                width: 100%;
                height: 100%;
            }
        }

        .p_text1 {
            font-weight: 500;
            font-size: 16px;
            color: #000000;
            line-height: 33px;
            display: flex;
            flex-flow: row;
            align-items: center;

            img {
                width: 20px;
                height: 20px;
                margin-left: 5px;
            }
        }
    }
    .cancel_pay_content {
        .cancel_text {
            font-weight: bold;
            font-size: 20px;
            color: #000000;
        }

        .cancel_text {
            font-size: 16px;
            color: #000000;
        }
    }

    .result-image {
        >>>.icon-warning {
            fill: red;
        }
    }
}

.exam_seat_page_small {

}

@media (max-width: 640px) {
    .exam_seat_page {
        padding: 0 0;

        .exac_title {
            font-size: 5vw;
        }

        .exam_seat_content {
            overflow: scroll;
            height: calc(100vh - 36vh);
        }

        .exam_rules {
            margin-bottom: 3vw;

            .rules_list {
                li {
                    font-size: 3vw;
                    line-height: 4.2vw;
                    margin-bottom: 2vw;
                }

                li:last-child {
                    padding-bottom: 3vw;
                }
            }
        }

        .exam_selection {
            .selection_select {
                display: grid;
                gap: 0;
                grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));

                .selection_title {
                    width: 100%;
                    margin-bottom: 3vw;

                    >>>.el-input__inner {
                        // height: 10vw !important;
                        // line-height: 10vw !important;
                        // background-color: #FAFCFF;
                        // border-radius: 10px;
                        // border: 1px solid #78A0D0;
                    }
                }
            }

            .slot_options {
                max-height: 70vw;

                .el-radio {
                    width: 100%;
                }

                .el-radio-group {
                    grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
                }

                .slot_item {
                    .slot_time {
                        .label, .value {
                            font-size: 3.6vw;
                        }
                    }

                    .slot_seats, .slot_duration, .slot_deadline {
                        img {
                            width: 3.8vw;
                        }

                        .label, .value {
                            font-size: 3vw;
                            line-height: 5vw;
                        }
                    }
                }
            }

            .confirm_btn {
                width: 100%;
                height: 12vw;
                font-size: 4.2vw;
            }

            .re_confirm_btn {
                bottom: 1vw;
                right: 2vw;
                z-index: 2;
                width: 100%;
                background-color: #fff;

                > div {
                    width: 100%;
                }

                .p1 {
                    display: none;

                    img {
                        width: 18px;
                    }
                }

                .p2 {
                    display: flex;
                    flex-flow: row;
                    align-items: center;
                    justify-content: flex-end;

                    p {
                        border-radius: 5vw;
                        font-size: 3.8vw;
                        padding: 2vw 6vw;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .sure_pay_content {
            padding: 5vw;

            .p_text {
                font-size: 4.4vw;
                color: #011E41;

                >span {
                    font-size: 5vw;
                }
            }

            .p_img {
                width: 58vw;
                height: 58vw;
                margin: 2vw auto;

                // border: 1px solid #011E41;
                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .p_text1 {
                font-size: 3.2vw;

                img {
                    width: 4vw;
                    height: 4vw;
                    margin-left: 1vw;
                }
            }
        }

        .cancel_pay_content {
            .cancel_text {
                font-size: 5vw;
            }

            .cancel_text1 {
                font-size: 3.4vw;
            }
        }
    }
}


</style>